import { useMemo } from 'react';
import { useFetchQuizesQuery } from '../quizesApi';
import { useCourse, useCourseQuizPages } from '../../course/hooks';

export const useQuizes = (params = {}, options = {}) => {
  return useFetchQuizesQuery(params, {
    ...options,
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      quizesData: data || [],
      isLoading,
      isError,
      error,
    }),
  });
};

export const useQuizById = ({ courseId, quizId }) => {
  const { quizesData, isLoading, isError, error } = useQuizes({ courseId }, { skip: !courseId });
  const quiz = useMemo(() => (quizesData || []).find(q => String(q.id) === String(quizId)) || null, [quizesData, quizId]);
  return { quiz, isLoading, isError, error };
};

export const useQuizesInfo = (courseId) => {
  const course = useCourse();
  const quizPages = useCourseQuizPages();
  const { quizesData, isLoading, isError, error } = useQuizes({ courseId }, { skip: !courseId });

  const info = useMemo(() => {
    const tocQuiz = Array.isArray(course?.toc)
      ? course.toc.filter((el) => el.type === 'quiz').map((el) => el.pages?.[0]).filter(Boolean)
      : [];

    const result = {};
    tocQuiz.forEach((value) => {
      if (!quizPages || !value) return;
      const apiInfo = (quizesData || []).find((element) => String(element.id) === String(value.id));
      const page = quizPages && quizPages[value.id];
      result[value.id] = {
        ...value,
        ...page,
        ...apiInfo,
      };
    });
    return Object.values(result);
  }, [course?.toc, quizPages, quizesData]);

  return { quizesInfo: info, isLoading, isError, error };
};
